<template>
	<main>
		<div class="content">
			<iframe
				src="https://docs.google.com/forms/d/e/1FAIpQLSeFzPfqsimr9bWhUGcy0nkylYhOtYlmJ52DQm35pGKXFM4H5w/viewform?embedded=true"
				height="1575"
				frameborder="0"
				marginheight="0"
				marginwidth="0"
				class="iframe-form"
			>
				Loading…
			</iframe>
		</div>

		<!-- Sub components of AppFooter NuxtLazyHydrate -->
		<AppFooter />
	</main>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.content {
	margin-top: 32px;
}

.iframe-form {
	width: 100%;
}
</style>
